module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"available":"Available"},"de":{"available":"Verfügbar"}}')
  delete Component.options._Ctor
}
